import React from 'react';
import {
  Container,
  Box,
  Typography,
  Paper,
  Breadcrumbs,
  Link
} from '@mui/material';
import { Analytics, Home } from '@mui/icons-material';
import { ReportsAnalytics } from '../../components/admin/ReportsAnalytics';
import { useCurrentUser } from '../../hooks/useApi';
import { Navigate, useNavigate } from 'react-router-dom';

export const AnalyticsAdmin: React.FC = () => {
  const { data: user } = useCurrentUser();
  const navigate = useNavigate();

  // Redirect if user doesn't have admin permission
  if (!user?.permissions?.includes('market_compass.admin')) {
    return <Navigate to="/" replace />;
  }

  return (
    <Container maxWidth="xl">
      <Box sx={{ py: 4 }}>
        {/* Breadcrumbs */}
        <Breadcrumbs sx={{ mb: 3 }}>
          <Link
            color="inherit"
            href="/"
            onClick={(e) => {
              e.preventDefault();
              navigate('/');
            }}
            sx={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}
          >
            <Home sx={{ mr: 0.5 }} fontSize="small" />
            Home
          </Link>
          <Link
            color="inherit"
            href="/admin/hub"
            onClick={(e) => {
              e.preventDefault();
              navigate('/admin/hub');
            }}
            sx={{ cursor: 'pointer' }}
          >
            Admin Hub
          </Link>
          <Typography color="text.primary">Analytics Dashboard</Typography>
        </Breadcrumbs>

        {/* Header */}
        <Box sx={{ mb: 4 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
            <Analytics sx={{ mr: 2, fontSize: 40, color: 'primary.main' }} />
            <Typography variant="h4" component="h1">
              Analytics Dashboard
            </Typography>
          </Box>
          <Typography variant="body1" color="text.secondary">
            View download statistics and user engagement across all MarketCompass assets
          </Typography>
        </Box>

        <ReportsAnalytics />
      </Box>
    </Container>
  );
};